import React from 'react'

const Corporate = (): JSX.Element => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.8256 6.3862C10.9925 5.71845 11.5925 5.25 12.2808 5.25H16.7192C17.4075 5.25 18.0075 5.71845 18.1744 6.3862C18.4111 7.33292 17.6951 8.25 16.7192 8.25H12.2808C11.3049 8.25 10.5889 7.33292 10.8256 6.3862ZM12.2808 6.25C12.0513 6.25 11.8514 6.40615 11.7957 6.62873C11.7168 6.94431 11.9555 7.25 12.2808 7.25H16.7192C17.0445 7.25 17.2832 6.94431 17.2043 6.62873C17.1486 6.40615 16.9487 6.25 16.7192 6.25H12.2808Z"
      // fill="#565B5D"
    />
    <path
      d="M17.5 10.75C18.0523 10.75 18.5 10.3023 18.5 9.75C18.5 9.19772 18.0523 8.75 17.5 8.75C16.9477 8.75 16.5 9.19772 16.5 9.75C16.5 10.3023 16.9477 10.75 17.5 10.75Z"
      // fill="#565B5D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.28078 11.25C6.59247 11.25 5.9925 11.7184 5.82556 12.3862C5.58888 13.3329 6.30492 14.25 7.28078 14.25H11.7192C12.6951 14.25 13.4111 13.3329 13.1744 12.3862C13.0075 11.7184 12.4075 11.25 11.7192 11.25H7.28078ZM6.79571 12.6287C6.85135 12.4061 7.05134 12.25 7.28078 12.25H11.7192C11.9487 12.25 12.1486 12.4061 12.2043 12.6287C12.2832 12.9443 12.0445 13.25 11.7192 13.25H7.28078C6.95549 13.25 6.71681 12.9443 6.79571 12.6287Z"
      // fill="#565B5D"
    />
    <path
      d="M6.5 16.75C7.05228 16.75 7.5 16.3023 7.5 15.75C7.5 15.1977 7.05228 14.75 6.5 14.75C5.94772 14.75 5.5 15.1977 5.5 15.75C5.5 16.3023 5.94772 16.75 6.5 16.75Z"
      // fill="#565B5D"
    />
    <path
      d="M13.5 15.75C13.5 16.3023 13.0523 16.75 12.5 16.75C11.9477 16.75 11.5 16.3023 11.5 15.75C11.5 15.1977 11.9477 14.75 12.5 14.75C13.0523 14.75 13.5 15.1977 13.5 15.75Z"
      // fill="#565B5D"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.60961 3.25L8.10961 9.25H4.60961L3.13436 15.151C3.04512 15.508 3 15.8745 3 16.2424V18.75H4.5V19.75C4.5 20.3023 4.94772 20.75 5.5 20.75C6.05228 20.75 6.5 20.3023 6.5 19.75V18.75H12.5V19.75C12.5 20.3023 12.9477 20.75 13.5 20.75C14.0523 20.75 14.5 20.3023 14.5 19.75V18.75H16V16.2424C16 15.8745 15.9549 15.508 15.8656 15.151L15.2654 12.75H17.5V13.75C17.5 14.3023 17.9477 14.75 18.5 14.75C19.0523 14.75 19.5 14.3023 19.5 13.75V12.75H21V10.2424C21 9.87449 20.9549 9.50795 20.8656 9.15101L19.3904 3.25H9.60961ZM20 11.75H15.0154L14.3904 9.25H9.14039L10.3904 4.25H18.6096L19.8955 9.39355C19.9649 9.67117 20 9.95626 20 10.2424V11.75ZM15 17.75V16.2424C15 15.9563 14.9649 15.6712 14.8955 15.3935L13.6096 10.25H5.39039L4.1045 15.3935C4.0351 15.6712 4 15.9563 4 16.2424V17.75H15Z"
      // fill="#565B5D"
    />
  </svg>
)

export default Corporate
